import { TYPES } from 'action-types/extraDocument';
import * as msgs from '../../constants/validationMessages';
import {
    EmptyExportExtraDocumentConfiguration,
    EmptyImportExtraDocumentConfiguration,
    IExportExtraDocumentConfiguration,
    IExportExtraDocumentConfigurations,
    IImportExtraDocumentConfiguration,
    IImportExtraDocumentConfigurations,
} from 'reducers/extraDocument/models';

export interface IExtraDocumentConfigurationsAction {
    readonly type: string;
    readonly errors?: string | string[];
    readonly exportExtraDocumentConfigs: IExportExtraDocumentConfigurations;
    readonly importExtraDocumentConfigs: IImportExtraDocumentConfigurations;
    readonly exportExtraDocumentConfig: IExportExtraDocumentConfiguration;
    readonly importExtraDocumentConfig: IImportExtraDocumentConfiguration;
    readonly addExportResponse: any;
    readonly updateExportResponse: any;
    readonly addImportResponse: any;
    readonly updateImportResponse: any;
    readonly toggleActiveResponse: any;
    readonly issorates: any;
    readonly extraDocumentCreationImport: any;
    readonly extraDocumentCreationExport: any;
    readonly processExtraDocumentCreationImportRes: any;
    readonly processExtraDocumentCreationExportRes: any;
}

export interface IExtraDocumentConfigurationsState {
    readonly isFetchDataLoading: boolean;
    readonly isFetchDataError: boolean;
    readonly pendingError: string | string[];
    readonly exportExtraDocumentConfigs: IExportExtraDocumentConfigurations;
    readonly importExtraDocumentConfigs: IImportExtraDocumentConfigurations;
    readonly exportExtraDocumentConfig: IExportExtraDocumentConfiguration;
    readonly importExtraDocumentConfig: IImportExtraDocumentConfiguration;
    readonly addExportResponse: any;
    readonly updateExportResponse: any;
    readonly addImportResponse: any;
    readonly updateImportResponse: any;
    readonly toggleActiveResponse: any;
    readonly issorates: any;
    readonly extraDocumentCreationImport: any;
    readonly extraDocumentCreationExport: any;
    readonly processExtraDocumentCreationImportRes: any;
    readonly processExtraDocumentCreationExportRes: any;
}

export const defaultState: IExtraDocumentConfigurationsState = {
    isFetchDataError: false,
    pendingError: '',
    isFetchDataLoading: false,
    exportExtraDocumentConfigs: {
        pageNumber: 1,
        page: 1,
        pageSize: 0,
        result: [],
        totalCount: 0
    },
    importExtraDocumentConfigs: {
        pageNumber: 1,
        page: 1,
        pageSize: 0,
        result: [],
        totalCount: 0
    },
    extraDocumentCreationImport: {
        page: 1,
        pageSize: 0,
        result: [],
        totalCount: 0
    },
    extraDocumentCreationExport: {
        page: 1,
        pageSize: 0,
        result: [],
        totalCount: 0
    },
    exportExtraDocumentConfig: EmptyExportExtraDocumentConfiguration,
    importExtraDocumentConfig: EmptyImportExtraDocumentConfiguration,
    addExportResponse: undefined,
    updateExportResponse: undefined,
    addImportResponse: undefined,
    updateImportResponse: undefined,
    toggleActiveResponse: undefined,
    issorates: undefined,
    processExtraDocumentCreationImportRes: undefined,
    processExtraDocumentCreationExportRes: undefined
};

export const reducer = (state: IExtraDocumentConfigurationsState = defaultState, action: IExtraDocumentConfigurationsAction): IExtraDocumentConfigurationsState => {
    switch (action.type) {
        case TYPES.SEARCH_EXPORT_EXTRA_DOCUMENT_CONFIGURATION.PENDING:
            return {
                ...state,
                isFetchDataLoading: true,
                isFetchDataError: false,
                pendingError: ''
            };
        case TYPES.SEARCH_EXPORT_EXTRA_DOCUMENT_CONFIGURATION.FULFILLED:
            return {
                ...state,
                exportExtraDocumentConfigs: action.exportExtraDocumentConfigs,
                isFetchDataLoading: false,
                isFetchDataError: false,
                pendingError: action.exportExtraDocumentConfigs && action.exportExtraDocumentConfigs.result.length > 0 ? '' : msgs.ExtraDocument.Pending_Error
            };
        case TYPES.SEARCH_EXPORT_EXTRA_DOCUMENT_CONFIGURATION.REJECTED:
            return {
                ...state,
                isFetchDataLoading: false,
                isFetchDataError: true,
                pendingError: action.errors && action.errors.length ? action.errors.toString() : msgs.ExtraDocument.Error_Msg
            };
        case TYPES.SEARCH_IMPORT_EXTRA_DOCUMENT_CONFIGURATION.PENDING:
            return {
                ...state,
                isFetchDataLoading: true,
                isFetchDataError: false,
                pendingError: ''
            };
        case TYPES.SEARCH_IMPORT_EXTRA_DOCUMENT_CONFIGURATION.FULFILLED:
            return {
                ...state,
                importExtraDocumentConfigs: action.importExtraDocumentConfigs,
                isFetchDataLoading: false,
                isFetchDataError: false,
                pendingError: action.exportExtraDocumentConfigs && action.exportExtraDocumentConfigs.result.length > 0 ? '' : msgs.ExtraDocument.Pending_Error
            };
        case TYPES.SEARCH_IMPORT_EXTRA_DOCUMENT_CONFIGURATION.REJECTED:
            return {
                ...state,
                isFetchDataLoading: false,
                isFetchDataError: true,
                pendingError: action.errors && action.errors.length ? action.errors.toString() : msgs.ExtraDocument.Error_Msg
            };
        case TYPES.FETCH_EXPORT_EXTRA_DOCUMENT_CONFIGURATION_BY_ID.PENDING:
            return {
                ...state,
                exportExtraDocumentConfig: defaultState.exportExtraDocumentConfig,
                isFetchDataLoading: true,
                isFetchDataError: false,
                pendingError: ''
            };
        case TYPES.FETCH_EXPORT_EXTRA_DOCUMENT_CONFIGURATION_BY_ID.FULFILLED:
            return {
                ...state,
                exportExtraDocumentConfig: action.exportExtraDocumentConfig,
                isFetchDataLoading: false,
                isFetchDataError: false,
                pendingError: ''
            };
        case TYPES.FETCH_EXPORT_EXTRA_DOCUMENT_CONFIGURATION_BY_ID.REJECTED:
            return {
                ...state,
                isFetchDataLoading: false,
                isFetchDataError: true,
                pendingError: action.errors && action.errors.length ? action.errors : msgs.ExtraDocument.Error_Msg
            };
        case TYPES.FETCH_EXPORT_EXTRA_DOCUMENT_CONFIGURATION_BY_ID.RESET_ERROR:
            return {
                ...state,
                exportExtraDocumentConfig: defaultState.exportExtraDocumentConfig,
                pendingError: '',
                addExportResponse: undefined,
                updateExportResponse: undefined,
                toggleActiveResponse: undefined
            };
        case TYPES.ADD_EXPORT_EXTRA_DOCUMENT_CONFIGURATION.PENDING:
            return {
                ...state,
                addExportResponse: defaultState.addExportResponse,
                isFetchDataLoading: true,
                isFetchDataError: false,
                pendingError: ''
            };
        case TYPES.ADD_EXPORT_EXTRA_DOCUMENT_CONFIGURATION.FULFILLED:
            return {
                ...state,
                addExportResponse: true,
                isFetchDataLoading: false,
                isFetchDataError: false,
                pendingError: ''
            };
        case TYPES.ADD_EXPORT_EXTRA_DOCUMENT_CONFIGURATION.REJECTED:
            return {
                ...state,
                addExportResponse: false,
                isFetchDataLoading: false,
                isFetchDataError: true,
                pendingError: action.errors && action.errors.length ? action.errors : msgs.ExtraDocument.Error_Msg
            };
        case TYPES.UPDATE_EXPORT_EXTRA_DOCUMENT_CONFIGURATION.PENDING:
            return {
                ...state,
                updateExportResponse: defaultState.updateExportResponse,
                isFetchDataLoading: true,
                isFetchDataError: false,
                pendingError: ''
            };
        case TYPES.UPDATE_EXPORT_EXTRA_DOCUMENT_CONFIGURATION.FULFILLED:
            return {
                ...state,
                updateExportResponse: true,
                isFetchDataLoading: false,
                isFetchDataError: false,
                pendingError: ''
            };
        case TYPES.UPDATE_EXPORT_EXTRA_DOCUMENT_CONFIGURATION.REJECTED:
            return {
                ...state,
                updateExportResponse: false,
                isFetchDataLoading: false,
                isFetchDataError: true,
                pendingError: action.errors && action.errors.length ? action.errors : msgs.ExtraDocument.Error_Msg
            };
        case TYPES.FETCH_IMPORT_EXTRA_DOCUMENT_CONFIGURATION_BY_ID.PENDING:
            return {
                ...state,
                importExtraDocumentConfig: defaultState.importExtraDocumentConfig,
                isFetchDataLoading: true,
                isFetchDataError: false,
                pendingError: ''
            };
        case TYPES.FETCH_IMPORT_EXTRA_DOCUMENT_CONFIGURATION_BY_ID.FULFILLED:
            return {
                ...state,
                importExtraDocumentConfig: action.importExtraDocumentConfig,
                isFetchDataLoading: false,
                isFetchDataError: false,
                pendingError: ''
            };
        case TYPES.FETCH_IMPORT_EXTRA_DOCUMENT_CONFIGURATION_BY_ID.REJECTED:
            return {
                ...state,
                isFetchDataLoading: false,
                isFetchDataError: true,
                pendingError: action.errors && action.errors.length ? action.errors : msgs.ExtraDocument.Error_Msg
            };
        case TYPES.FETCH_IMPORT_EXTRA_DOCUMENT_CONFIGURATION_BY_ID.RESET_ERROR:
            return {
                ...state,
                importExtraDocumentConfig: defaultState.importExtraDocumentConfig,
                pendingError: '',
                addImportResponse: undefined,
                updateImportResponse: undefined,
                toggleActiveResponse: undefined
            };
        case TYPES.ADD_IMPORT_EXTRA_DOCUMENT_CONFIGURATION.PENDING:
            return {
                ...state,
                addImportResponse: defaultState.addImportResponse,
                isFetchDataLoading: true,
                isFetchDataError: false,
                pendingError: ''
            };
        case TYPES.ADD_IMPORT_EXTRA_DOCUMENT_CONFIGURATION.FULFILLED:
            return {
                ...state,
                addImportResponse: true,
                isFetchDataLoading: false,
                isFetchDataError: false,
                pendingError: ''
            };
        case TYPES.ADD_IMPORT_EXTRA_DOCUMENT_CONFIGURATION.REJECTED:
            return {
                ...state,
                addImportResponse: false,
                isFetchDataLoading: false,
                isFetchDataError: true,
                pendingError: action.errors && action.errors.length ? action.errors : msgs.ExtraDocument.Error_Msg
            };
        case TYPES.UPDATE_IMPORT_EXTRA_DOCUMENT_CONFIGURATION.PENDING:
            return {
                ...state,
                updateImportResponse: defaultState.updateImportResponse,
                isFetchDataLoading: true,
                isFetchDataError: false,
                pendingError: ''
            };
        case TYPES.UPDATE_IMPORT_EXTRA_DOCUMENT_CONFIGURATION.FULFILLED:
            return {
                ...state,
                updateImportResponse: true,
                isFetchDataLoading: false,
                isFetchDataError: false,
                pendingError: ''
            };
        case TYPES.UPDATE_IMPORT_EXTRA_DOCUMENT_CONFIGURATION.REJECTED:
            return {
                ...state,
                updateImportResponse: false,
                isFetchDataLoading: false,
                isFetchDataError: true,
                pendingError: action.errors && action.errors.length ? action.errors : msgs.ExtraDocument.Error_Msg
            };
        case TYPES.TOGGLE_ACTIVE_EXTRA_DOCUMENT_CONFIGURATION.PENDING:
            return {
                ...state,
                toggleActiveResponse: defaultState.toggleActiveResponse,
                isFetchDataLoading: true,
                isFetchDataError: false,
                pendingError: ''
            };
        case TYPES.TOGGLE_ACTIVE_EXTRA_DOCUMENT_CONFIGURATION.FULFILLED:
            return {
                ...state,
                toggleActiveResponse: true,
                isFetchDataLoading: false,
                isFetchDataError: false,
                pendingError: ''
            };
        case TYPES.TOGGLE_ACTIVE_EXTRA_DOCUMENT_CONFIGURATION.REJECTED:
            return {
                ...state,
                toggleActiveResponse: false,
                isFetchDataLoading: false,
                isFetchDataError: true,
                pendingError: action.errors && action.errors.length ? action.errors : msgs.ExtraDocument.Error_Msg
            };
        case TYPES.FETCH_ESSO_RATES.REJECTED:
            return {
                ...state,
                updateImportResponse: false,
                isFetchDataLoading: false,
                isFetchDataError: true,
                pendingError: action.errors && action.errors.length ? action.errors : msgs.ExtraDocument.Error_Msg
            };
        case TYPES.FETCH_ESSO_RATES.PENDING:
            return {
                ...state,
                issorates: defaultState.issorates,
                isFetchDataLoading: true,
                isFetchDataError: false,
                pendingError: ''
            };
        case TYPES.FETCH_ESSO_RATES.FULFILLED:
            return {
                ...state,
                issorates: action.issorates,
                isFetchDataLoading: false,
                isFetchDataError: false,
                pendingError: ''
            };
        case TYPES.FETCH_ESSO_RATES.REJECTED:
            return {
                ...state,
                issorates: defaultState.issorates,
                isFetchDataLoading: false,
                isFetchDataError: true,
                pendingError: action.errors && action.errors.length ? action.errors : msgs.ExtraDocument.Error_Msg
            };

        case TYPES.EXTRA_DOCUMENT_CREATION_IMPORT.PENDING:
            return {
                ...state,
                extraDocumentCreationImport: defaultState.extraDocumentCreationImport,
                isFetchDataLoading: true,
                isFetchDataError: false,
                pendingError: ''
            };
        case TYPES.EXTRA_DOCUMENT_CREATION_IMPORT.FULFILLED:
            return {
                ...state,
                extraDocumentCreationImport: action.extraDocumentCreationImport,
                isFetchDataLoading: false,
                isFetchDataError: false,
                pendingError: ''
            };
        case TYPES.EXTRA_DOCUMENT_CREATION_IMPORT.REJECTED:
            return {
                ...state,
                extraDocumentCreationImport: defaultState.extraDocumentCreationImport,
                isFetchDataLoading: false,
                isFetchDataError: true,
                pendingError: action.errors && action.errors.length ? action.errors : msgs.ExtraDocument.Error_Msg
            };

            case TYPES.EXTRA_DOCUMENT_CREATION_EXPORT.PENDING:
            return {
                ...state,
                extraDocumentCreationExport: defaultState.extraDocumentCreationExport,
                isFetchDataLoading: true,
                isFetchDataError: false,
                pendingError: ''
            };
        case TYPES.EXTRA_DOCUMENT_CREATION_EXPORT.FULFILLED:
            return {
                ...state,
                extraDocumentCreationExport: action.extraDocumentCreationExport,
                isFetchDataLoading: false,
                isFetchDataError: false,
                pendingError: ''
            };
        case TYPES.EXTRA_DOCUMENT_CREATION_EXPORT.REJECTED:
            return {
                ...state,
                extraDocumentCreationExport: defaultState.extraDocumentCreationExport,
                isFetchDataLoading: false,
                isFetchDataError: true,
                pendingError: action.errors && action.errors.length ? action.errors : msgs.ExtraDocument.Error_Msg
            };
        
        case TYPES.PROCESS_EXTRA_DOCUMENT_CREATION_EXPORT.PENDING:
                return {
                    ...state,
                    processExtraDocumentCreationExportRes: defaultState.processExtraDocumentCreationExportRes,
                    isFetchDataLoading: true,
                    isFetchDataError: false,
                    pendingError: ''
                };
        case TYPES.PROCESS_EXTRA_DOCUMENT_CREATION_EXPORT.FULFILLED:
                return {
                    ...state,
                    processExtraDocumentCreationExportRes: true,
                    isFetchDataLoading: false,
                    isFetchDataError: false,
                    pendingError: ''
                };
        case TYPES.PROCESS_EXTRA_DOCUMENT_CREATION_EXPORT.REJECTED:
                return {
                    ...state,
                    processExtraDocumentCreationExportRes: false,
                    isFetchDataLoading: false,
                    isFetchDataError: true,
                    pendingError: action.errors && action.errors.length ? action.errors : msgs.ExtraDocument.Error_Msg
                };
            case TYPES.PROCESS_EXTRA_DOCUMENT_CREATION_IMPORT.PENDING:
                    return {
                        ...state,
                        processExtraDocumentCreationImportRes: defaultState.processExtraDocumentCreationImportRes,
                        isFetchDataLoading: true,
                        isFetchDataError: false,
                        pendingError: ''
                    };
            case TYPES.PROCESS_EXTRA_DOCUMENT_CREATION_IMPORT.FULFILLED:
                    return {
                        ...state,
                        processExtraDocumentCreationImportRes: true,
                        isFetchDataLoading: false,
                        isFetchDataError: false,
                        pendingError: ''
                    };
            case TYPES.PROCESS_EXTRA_DOCUMENT_CREATION_IMPORT.REJECTED:
                    return {
                        ...state,
                        processExtraDocumentCreationImportRes: false,
                        isFetchDataLoading: false,
                        isFetchDataError: true,
                        pendingError: action.errors && action.errors.length ? action.errors : msgs.ExtraDocument.Error_Msg
                    };
     
            default:
            return state;
    }
};
